import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import { sentOtpFunction } from "./Service/Apis";
import Spinner from "react-bootstrap/Spinner";
import "react-toastify/dist/ReactToastify.css";
import "./OTP.css";

const Login = () => {

	const [email, setEmail] = useState("");
	const [spiner,setSpiner] = useState(false);

	const navigate = useNavigate();

	const sendOtp = async (e) => {
		e.preventDefault();

		if (email === "") {
			toast.error("Enter Your Email !")
		} else if (!email.includes("@")) {
			toast.error("Enter Valid Email !")
		} else {
			setSpiner(true)
			const data = {
				email: email
			}

			const response = await sentOtpFunction(data);

			if (response.status === 200) {
				setSpiner(false)
				navigate("/user/otp",{state:email})
			} else {
				toast.error(response.response.data.error);
			}
		}
	}

	return (
		<div>
			<div className="form_data home-container-2">
				<div className="form_heading">
					<h1>
						Welcome Back, Login
					</h1>
					<p className="form_heading_tag">
						Hi, we are you glad you are back. Please login.
					</p>
				</div>
				<form>
					<div className="form_input">
						<label htmlFor="email" className="form_input_name">
							Email
						</label>
						<input type="email" name="email" id="" className="form_input_box" onChange={(e) => setEmail(e.target.value)} placeholder='Enter your Email Address' />
					</div>
					<button className="form_button" onClick={sendOtp}>LOGIN
					{
						spiner ? <span><Spinner animation="border" /></span>:""
					}
					</button>
					<p>
						Not registered yet. <NavLink to="/register">Register</NavLink>
					</p>
				</form>
			</div>
			<ToastContainer />
		</div>      
	)
}

export default Login;